import React, { lazy } from 'react';
import { connect } from 'react-redux'
import agent from '../../agent'
import '../../styles/components.css'
import '../../styles/main.css'
import '../../styles/responsive.css'
import '../../styles/styleAdmin.css'

import $ from 'jquery';
import { Dropdown } from 'react-bootstrap';
//import { Cookies } from 'react-cookie';
import { AlertList } from "react-bs-notifier";
import ReactLoading from 'react-loading';
import ReactPaginate from 'react-paginate';
import SchoolSetupMenu from './SchoolSetupMenu';
import EditStatus from './EditStatus';

const mapStateToProps = state => (
  Object.assign({}, state, {
  })
);

const mapDispatchToProps = dispatch => ({
});

class Status extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      delayTimer: null, school_id: 0, isEdit: false, is_group_sync: 0, config_school_group: {},
      status_id: 0, school_name: "", applied_to: "student", view_mode: 'readonly', applyto_list: [],
      loaderspiner: false, list: [], count: 0, selected: 0, page: 1, pagesize: 20, sort_column: '', sort_dir: '', searchFields: [],
      showAlert: false, position: "bottom-right",
      alerts: [{
        id: (new Date()).getTime(),
        type: "success",
        message: 'Successfully.'
      }],saupdatestatus:false,
    }
    this.handlePageClick = data => {
      //console.log(data)
      let selected = data.selected;
      //let offset = Math.ceil(selected * this.state.pagesize);
      let offset = Math.ceil(selected + 1);
      this.setState({ page: offset, selected: selected }, () => {
        this.get_status_list();
      });
    }
    this.handleCheckbox = (field, ev) => {
      this.setState({ [field]: ev.target.checked ? 1 : 0 }, () => {
      });
    }
    this.handlePhone = (value) => {
      this.setState({ contact_number: value });
    }
    this.handleInput = (field, ev) => {
      this.setState({ [field]: ev.target.value });
    }
    this.handleAppliedTo = (field, ev) => {
      this.setState({ applied_to: ev.target.value }, () => {
        this.get_status_list();
      });
    }
    this.handleSearchColumn = () => {
      clearTimeout(this.state.delayTimer);
      this.setState({
        delayTimer: setTimeout(() => {
          let fields = {};
          $("input[type=search], select").each(
            function () {
              var input = $(this);
              if (input.attr("type") == "checkbox" || input.attr("type") == "radio") {
                if (input.is(":checked")) {
                  fields[input.attr('id')] = input.val();
                }
              } else {
                fields[input.attr('id')] = input.val();
              }
            }
          );
          this.setState({ searchFields: fields, page: 1, selected: 0 }, () => {
            this.get_status_list();
          });
        }, 500)
      });
    }

    this.get_configuration_by_schoolid = () => {
      let params = {
        school_id: this.state.school_id
      };
      agent.superadmin.get_configuration_by_schoolid(params).then(datas => {
        //console.log(datas)
        if (datas.status === true) {
          let data = datas.data;
          this.setState({
            config_school_group: data
          });
        }
      })
    }
    this.get_applyto_list = () => {
      let params = {
      };
      for (let prop in this.state.searchFields) {
        params[prop] = this.state.searchFields[prop];
      }
      this.setState({ loaderspiner: true });
      agent.admin.get_applyto_list(params).then(datas => {
        //console.log(datas)
        this.setState({ loaderspiner: false });
        if (datas.status === true) {
          let data = datas.data;
          this.setState({
            applyto_list: data
          });
        }
      })
    }
    this.get_status_list = () => {
      let params = {
        page: this.state.page,
        page_size: this.state.pagesize,
        applied_to: this.state.applied_to,
        sort_column: this.state.sort_column,
        sort_dir: this.state.sort_dir,
        school_id: this.state.school_id,
      };
      for (let prop in this.state.searchFields) {
        params[prop] = this.state.searchFields[prop];
      }
      this.setState({ loaderspiner: true });
      agent.admin.get_status_list(params).then(datas => {
        //console.log(datas)
        this.setState({ loaderspiner: false });
        if (datas.status === true) {
          let data = datas.data;
          this.setState({
            list: data.list,
            count: data.count >= 0 ? data.count : this.state.count
          });
        }
      })
    }
    this.hideEditComment = () => {
      this.setState({ is_edit_comment: false }, () => {
        this.get_status_list();
      });
    }
    this.handleSort = (sortColumn, sortDir) => {
      this.setState({ sort_column: sortColumn, sort_dir: sortDir }, () => {
        this.get_status_list();
      });
    }
    this.delete_status = (status_id) => {
      let configSchoolGroup = this.state.config_school_group;
      let is_group_sync = 0;
      let confirm;
      if (configSchoolGroup.hasOwnProperty('statuses') && configSchoolGroup.statuses == 1) {
        confirm = window.confirm("This school belongs to school group " + configSchoolGroup.school_group_name + ".  Any changes made here will be applied to all schools in this school group. Do you want to proceed?");
        is_group_sync = confirm ? 1 : 0;
        if (!confirm) return;
      } else {
        is_group_sync = 0;
        confirm = window.confirm("Delete this record ?");
        if (!confirm) return;
      }
      let params = {
        status_id: status_id,
        is_group_sync: is_group_sync,
      }
      this.setState({ loaderspiner: true });
      agent.admin.delete_status(params).then(datas => {
        this.setState({ loaderspiner: false });
        //console.log(datas)
        if (datas.status === true) {
          this.get_status_list();
          this.setState({
            loaderspiner: false,
            showAlert: true,
            alerts: [{
              id: (new Date()).getTime(),
              type: "success",
              message: datas.message
            }],
          });
        } else {
          this.setState({
            showAlert: true,
            alerts: [{
              id: (new Date()).getTime(),
              type: "danger",
              message: datas.message
            }]
          })
        }
      })
    }
    this.editItem = (status_id, view_mode) => {
      this.setState({ isEdit: true, status_id: status_id, view_mode: view_mode }, () => {
      });
    }
    this.hideEdit = () => {
      this.setState({ isEdit: false , status_id: 0}, () => {
        this.get_status_list();
      });
    }
    this.showModalEror = (message) => {
      this.setState({ isOpenModal: true, msg: message })
    }
  }
  onAlertDismissed(alert) {
    const alerts = this.state.alerts;

    // find the index of the alert that was dismissed
    const idx = alerts.indexOf(alert);

    if (idx >= 0) {
      this.setState({
        // remove the alert from the array
        alerts: [...alerts.slice(0, idx), ...alerts.slice(idx + 1)]
      });
    }
  }
  componentDidMount() {

    //let userInfo = window.localStorage.getItem('USERLOG');
    let role_login=window.localStorage.getItem('last_role');
    let USERLOG=(parseInt(role_login)===1)?'USERLOGSUP':'USERLOG';
    let userInfo = window.localStorage.getItem(USERLOG);
    userInfo = JSON.parse(userInfo);
    //console.log(userInfo)
    let saupdatestatus = false;
      let setting_config = JSON.parse(window.localStorage.getItem('user_settings'));
      if (setting_config != undefined && setting_config != null && setting_config != '') {
        saupdatestatus = setting_config.hasOwnProperty('saupdatestatus') ? setting_config.saupdatestatus : false;    
    }
    if (userInfo !== undefined && userInfo !== '') {
      let userRole = userInfo.last_role;
      let schoolId = userInfo.last_school_id;
      let schoolName = userInfo.school_name;
      if (userRole == 1) {
        schoolId = window.localStorage.getItem('school_setup_id');
        schoolName = window.localStorage.getItem('school_setup_name');
      }
      this.setState({ school_name: schoolName, school_id: schoolId,saupdatestatus:saupdatestatus, }, () => {
        this.get_status_list();
        this.get_applyto_list();
        this.get_configuration_by_schoolid();
      })
    }
  }

  render() {
    let count = this.state.count
    let pagesize = this.state.pagesize
    let pageCount = Math.ceil(parseInt(count) / parseInt(pagesize))

    return (
      <div className="list_resource_pages_main_area">
        <div className="home-text-area">
          <div className="container">
            <div className="home-text-content">
              <h4>Home / Status / {this.state.school_name}</h4>
            </div>
          </div>
        </div>
        <div className="container" style={{ padding: '20px 10px', backgroundColor: '#fff' }}>
          <div className="row">
            <div className="col-3">
              <SchoolSetupMenu menu={'status'} />
            </div>
            <div className="col-9">
              <div style={{ display: `${this.state.isEdit ? 'none' : ''}` }}>
                
                <section className="row">
                  <div className="container">
                    <div className="list_prog_heading add-new-class mb-3" style={{ display: 'flex', justifyContent: 'end' }}>
					{(this.state.saupdatestatus) &&
                      <button className="btn_style_1" onClick={this.editItem.bind(this, 0, 'editable')}>Add new</button>
					}
                    </div>

                    <div className="resource-top-select-content">
                      <div className="dropdown_search_flex ar-gradebook-filter-wrapper">
                        {/*<!-- Start Dropdown Menu -->*/}
                        <div className="mu_dropdown_menu_content ar-gradebook-filter-dropdown" style={{flex: '100%'}}>
                          {/*<!-- End Mobile Menu icon -->*/}
                          <ul style={{ height: '50px' }}>
                            <li className="ar-gradebook-li-filter">Showing {this.state.list.length} of {this.state.count}</li>
                            {this.state.applyto_list != null && this.state.applyto_list.map((c, i) => {
                              return (
                                <React.Fragment key={i}>
                                  <li>
                                    <label htmlFor={c.value} style={{ display: 'flex', alignItems: 'center', height: '30px', marginBottom: '0' }}>
                                      <input type="radio" id={c.value} value={c.value} checked={this.state.applied_to == c.value} onChange={this.handleAppliedTo.bind(this, 'applied_to')} />
                                      <span style={{ marginLeft: '5px' }}>{c.label}</span>
                                    </label>
                                  </li>
                                </React.Fragment>
                              )
                            })}
                          </ul>
                        </div>
                        {/*<!-- End Dropdown Menu -->*/}

                      </div>
                    </div>
                    <table className="custom-table table-responsive-lg">
                      <thead className="custom-table-head">
                        <tr>
                          <th className="custom-table-th" width="">
                            <div className="w-100 d-flex align-items-start flex-column">
                              <div className='d-flex align-items-center justify-content-start mb-1'>
                                <div className="">Status Name</div>
                                <div className="d-flex d-inline flex-column ml-1">
                                  <div style={{ height: '13px' }} className='d-flex justify-content-center align-items-center cursor-pointer' onClick={this.handleSort.bind(this, 'status_name', 'asc')}>
                                    {(this.state.sort_column == 'status_name' && this.state.sort_dir == 'asc') ? (
                                      <img src="/media/learning/angel-top_bule.png" alt="images" />
                                    ) : (
                                      <img src="/media/learning/angel-top.png" alt="" />
                                    )}
                                  </div>
                                  <div style={{ height: '13px' }} className='d-flex justify-content-center align-items-center cursor-pointer' onClick={this.handleSort.bind(this, 'status_name', 'desc')}>
                                    {(this.state.sort_column == 'status_name' && this.state.sort_dir == 'desc') ? (
                                      <img src="/media/learning/angel-buttom-bule.png" alt="images" />
                                    ) : (
                                      <img src="/media/learning/angel-buttom.png" alt="" />
                                    )}
                                  </div>
                                </div>
                              </div>
                              <input type="search" className='form-control form-control2 w-100' placeholder="Search…" id="status_name" onChange={this.handleSearchColumn.bind(this)} />
                            </div>
                          </th>
                          <th className="custom-table-th">
                            <div className="w-100 d-flex align-items-start flex-column">
                              <div className='d-flex align-items-center justify-content-start mb-1'>
                                <div className="">Status state</div>
                                <div className="d-flex d-inline flex-column ml-1">
                                  <div style={{ height: '13px' }} className='d-flex justify-content-center align-items-center cursor-pointer' onClick={this.handleSort.bind(this, 'status_state', 'asc')}>
                                    {(this.state.sort_column == 'status_state' && this.state.sort_dir == 'asc') ? (
                                      <img src="/media/learning/angel-top_bule.png" alt="images" />
                                    ) : (
                                      <img src="/media/learning/angel-top.png" alt="" />
                                    )}
                                  </div>
                                  <div style={{ height: '13px' }} className='d-flex justify-content-center align-items-center cursor-pointer' onClick={this.handleSort.bind(this, 'status_state', 'desc')}>
                                    {(this.state.sort_column == 'status_state' && this.state.sort_dir == 'desc') ? (
                                      <img src="/media/learning/angel-buttom-bule.png" alt="images" />
                                    ) : (
                                      <img src="/media/learning/angel-buttom.png" alt="" />
                                    )}
                                  </div>
                                </div>
                              </div>
                              <input type="search" className='form-control form-control2 w-100' placeholder="Search…" id="status_state" onChange={this.handleSearchColumn.bind(this)} />
                            </div>
                          </th>
                          <th className="custom-table-th">
                            <div className="w-100 d-flex align-items-start flex-column">
                              <div className='d-flex align-items-center justify-content-start mb-1'>
                                <div className="">Initial</div>
                                <div className="d-flex d-inline flex-column ml-1">
                                  <div style={{ height: '13px' }} className='d-flex justify-content-center align-items-center cursor-pointer' onClick={this.handleSort.bind(this, 'initial', 'asc')}>
                                    {(this.state.sort_column == 'initial' && this.state.sort_dir == 'asc') ? (
                                      <img src="/media/learning/angel-top_bule.png" alt="images" />
                                    ) : (
                                      <img src="/media/learning/angel-top.png" alt="" />
                                    )}
                                  </div>
                                  <div style={{ height: '13px' }} className='d-flex justify-content-center align-items-center cursor-pointer' onClick={this.handleSort.bind(this, 'initial', 'desc')}>
                                    {(this.state.sort_column == 'initial' && this.state.sort_dir == 'desc') ? (
                                      <img src="/media/learning/angel-buttom-bule.png" alt="images" />
                                    ) : (
                                      <img src="/media/learning/angel-buttom.png" alt="" />
                                    )}
                                  </div>
                                </div>
                              </div>
                              {/* <input type="search" className='form-control form-control2 w-100' placeholder="Search…" id="initial" onChange={this.handleSearchColumn.bind(this)} /> */}
                            </div>
                          </th>
                          <th className="custom-table-th">
                            <div className="w-100 d-flex align-items-start flex-column">
                              <div className='d-flex align-items-center justify-content-start mb-1'>
                                <div className="">Block Access</div>
                                <div className="d-flex d-inline flex-column ml-1">
                                  <div style={{ height: '13px' }} className='d-flex justify-content-center align-items-center cursor-pointer' onClick={this.handleSort.bind(this, 'block_access', 'asc')}>
                                    {(this.state.sort_column == 'block_access' && this.state.sort_dir == 'asc') ? (
                                      <img src="/media/learning/angel-top_bule.png" alt="images" />
                                    ) : (
                                      <img src="/media/learning/angel-top.png" alt="" />
                                    )}
                                  </div>
                                  <div style={{ height: '13px' }} className='d-flex justify-content-center align-items-center cursor-pointer' onClick={this.handleSort.bind(this, 'block_access', 'desc')}>
                                    {(this.state.sort_column == 'block_access' && this.state.sort_dir == 'desc') ? (
                                      <img src="/media/learning/angel-buttom-bule.png" alt="images" />
                                    ) : (
                                      <img src="/media/learning/angel-buttom.png" alt="" />
                                    )}
                                  </div>
                                </div>
                              </div>
                              {/* <input type="search" className='form-control form-control2 w-100' placeholder="Search…" id="block_access" onChange={this.handleSearchColumn.bind(this)} /> */}
                            </div>
                          </th>
                          <th className="custom-table-th">
                            <div className="w-100 d-flex align-items-start flex-column">
                              <div className='d-flex align-items-center justify-content-start mb-1'>
                                <div className="">Terminating</div>
                                <div className="d-flex d-inline flex-column ml-1">
                                  <div style={{ height: '13px' }} className='d-flex justify-content-center align-items-center cursor-pointer' onClick={this.handleSort.bind(this, 'terminating', 'asc')}>
                                    {(this.state.sort_column == 'terminating' && this.state.sort_dir == 'asc') ? (
                                      <img src="/media/learning/angel-top_bule.png" alt="images" />
                                    ) : (
                                      <img src="/media/learning/angel-top.png" alt="" />
                                    )}
                                  </div>
                                  <div style={{ height: '13px' }} className='d-flex justify-content-center align-items-center cursor-pointer' onClick={this.handleSort.bind(this, 'terminating', 'desc')}>
                                    {(this.state.sort_column == 'terminating' && this.state.sort_dir == 'desc') ? (
                                      <img src="/media/learning/angel-buttom-bule.png" alt="images" />
                                    ) : (
                                      <img src="/media/learning/angel-buttom.png" alt="" />
                                    )}
                                  </div>
                                </div>
                              </div>
                              {/* <input type="search" className='form-control form-control2 w-100' placeholder="Search…" id="terminating" onChange={this.handleSearchColumn.bind(this)} /> */}
                            </div>
                          </th>
                          <th className="custom-table-th">
                            <div className="w-100 d-flex align-items-start flex-column">
                              <div className='d-flex align-items-center justify-content-start mb-1'>
                                <div className="">Status Comment</div>
                                <div className="d-flex d-inline flex-column ml-1">
                                  <div style={{ height: '13px' }} className='d-flex justify-content-center align-items-center cursor-pointer' onClick={this.handleSort.bind(this, 'status_comment', 'asc')}>
                                    {(this.state.sort_column == 'status_comment' && this.state.sort_dir == 'asc') ? (
                                      <img src="/media/learning/angel-top_bule.png" alt="images" />
                                    ) : (
                                      <img src="/media/learning/angel-top.png" alt="" />
                                    )}
                                  </div>
                                  <div style={{ height: '13px' }} className='d-flex justify-content-center align-items-center cursor-pointer' onClick={this.handleSort.bind(this, 'status_comment', 'desc')}>
                                    {(this.state.sort_column == 'status_comment' && this.state.sort_dir == 'desc') ? (
                                      <img src="/media/learning/angel-buttom-bule.png" alt="images" />
                                    ) : (
                                      <img src="/media/learning/angel-buttom.png" alt="" />
                                    )}
                                  </div>
                                </div>
                              </div>
                              {/* <input type="search" className='form-control form-control2 w-100' placeholder="Search…" id="status_comment" onChange={this.handleSearchColumn.bind(this)} /> */}
                            </div>
                          </th>
                          {/* <th className="custom-table-th">
                            <div className="w-100 d-flex align-items-start flex-column">
                              <div className='d-flex align-items-center justify-content-start mb-1'>
                                <div className="">System Only</div>
                                <div className="d-flex d-inline flex-column ml-1">
                                  <div style={{ height: '13px' }} className='d-flex justify-content-center align-items-center cursor-pointer' onClick={this.handleSort.bind(this, 'system_only', 'asc')}>
                                    {(this.state.sort_column == 'system_only' && this.state.sort_dir == 'asc') ? (
                                      <img src="/media/learning/angel-top_bule.png" alt="images" />
                                    ) : (
                                      <img src="/media/learning/angel-top.png" alt="" />
                                    )}
                                  </div>
                                  <div style={{ height: '13px' }} className='d-flex justify-content-center align-items-center cursor-pointer' onClick={this.handleSort.bind(this, 'system_only', 'desc')}>
                                    {(this.state.sort_column == 'system_only' && this.state.sort_dir == 'desc') ? (
                                      <img src="/media/learning/angel-buttom-bule.png" alt="images" />
                                    ) : (
                                      <img src="/media/learning/angel-buttom.png" alt="" />
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </th> */}
                          <th className="custom-table-th">
                            <div className="w-100 d-flex align-items-start flex-column">
                              <div className='d-flex align-items-center justify-content-start mb-1'>
                                <div className="">Withdrawn Enrollment</div>
                                <div className="d-flex d-inline flex-column ml-1">
                                  <div style={{ height: '13px' }} className='d-flex justify-content-center align-items-center cursor-pointer' onClick={this.handleSort.bind(this, 'withdrawn_enrollment', 'asc')}>
                                    {(this.state.sort_column == 'withdrawn_enrollment' && this.state.sort_dir == 'asc') ? (
                                      <img src="/media/learning/angel-top_bule.png" alt="images" />
                                    ) : (
                                      <img src="/media/learning/angel-top.png" alt="" />
                                    )}
                                  </div>
                                  <div style={{ height: '13px' }} className='d-flex justify-content-center align-items-center cursor-pointer' onClick={this.handleSort.bind(this, 'withdrawn_enrollment', 'desc')}>
                                    {(this.state.sort_column == 'withdrawn_enrollment' && this.state.sort_dir == 'desc') ? (
                                      <img src="/media/learning/angel-buttom-bule.png" alt="images" />
                                    ) : (
                                      <img src="/media/learning/angel-buttom.png" alt="" />
                                    )}
                                  </div>
                                </div>
                              </div>
                              {/* <input type="search" className='form-control form-control2 w-100' placeholder="Search…" id="withdrawn_enrollment" onChange={this.handleSearchColumn.bind(this)} /> */}
                            </div>
                          </th>
                          <th className="custom-table-th">
                            <div className="w-100 d-flex align-items-start flex-column">
                              <div className='d-flex align-items-center justify-content-start mb-1'>
                                <div className="">Off Limit</div>
                                <div className="d-flex d-inline flex-column ml-1">
                                  <div style={{ height: '13px' }} className='d-flex justify-content-center align-items-center cursor-pointer' onClick={this.handleSort.bind(this, 'off_limit', 'asc')}>
                                    {(this.state.sort_column == 'off_limit' && this.state.sort_dir == 'asc') ? (
                                      <img src="/media/learning/angel-top_bule.png" alt="images" />
                                    ) : (
                                      <img src="/media/learning/angel-top.png" alt="" />
                                    )}
                                  </div>
                                  <div style={{ height: '13px' }} className='d-flex justify-content-center align-items-center cursor-pointer' onClick={this.handleSort.bind(this, 'off_limit', 'desc')}>
                                    {(this.state.sort_column == 'off_limit' && this.state.sort_dir == 'desc') ? (
                                      <img src="/media/learning/angel-buttom-bule.png" alt="images" />
                                    ) : (
                                      <img src="/media/learning/angel-buttom.png" alt="" />
                                    )}
                                  </div>
                                </div>
                              </div>
                              {/* <input type="search" className='form-control form-control2 w-100' placeholder="Search…" id="off_limit" onChange={this.handleSearchColumn.bind(this)} /> */}
                            </div>
                          </th>
                          <th className="custom-table-th">
                          </th>
                        </tr>
                        <tr style={{ height: '8px' }}>
                        </tr>
                      </thead>
                      <tbody className="custom-table-body" id="tbody-request">

                        {(this.state.list !== null) ? this.state.list.map((c, i) => {
                          return (
                            <React.Fragment key={i}>
                              <tr className="custom-table-row">
                                <td className="custom-table-td">
                                  <a href='#' onClick={this.editItem.bind(this, c.status_id, 'readonly')}>{c.status_name}</a>
                                </td>
                                <td className="custom-table-td">
                                  {c.status_state}
                                </td>
                                <td className="custom-table-td">
                                  {c.initial}
                                </td>
                                <td className="custom-table-td">
                                  {c.block_access}
                                </td>
                                <td className="custom-table-td">
                                  {c.terminating}
                                </td>
                                <td className="custom-table-td">
                                  {c.status_comment}
                                </td>
                                {/* <td className="custom-table-td">
                                  {c.system_only}
                                </td> */}
                                <td className="custom-table-td">
                                  {c.withdrawn_enrollment}
                                </td>
                                <td className="custom-table-td">
                                  {c.off_limit}
                                </td>
                                <td className="custom-table-td">
								{(this.state.saupdatestatus) &&
                                  <Dropdown>
                                    <Dropdown.Toggle variant="success" id="newdropdownbtn" className="dropdown-toggle menu-drop ">
                                      <img src="/media/list-resource/more.png" alt="Images" style={{ width: '20px' }} />
                                    </Dropdown.Toggle>

                                    <Dropdown.Menu className="dropdown-menu new-menu new-class">
                                      <Dropdown.Item onClick={this.editItem.bind(this, c.status_id, 'editable')}>Edit</Dropdown.Item>
                                      <Dropdown.Item onClick={this.delete_status.bind(this, c.status_id)}>Delete</Dropdown.Item>
                                    </Dropdown.Menu>
                                  </Dropdown>
								}
                                </td>
                              </tr>
                              <tr style={{ height: '8px' }}></tr>
                            </React.Fragment>
                          )
                        }) : (<tr></tr>)}

                      </tbody>
                    </table>
                  </div>
                </section>
                <div className="row">
                  <div className="col-12 document_pagenations_area" style={{ display: 'flex', justifyContent: 'end' }}>
                    <div className="left_pg_area">
                      <a href="#">Showing {this.state.list.length} of {this.state.count}</a>
                    </div>
                    <div className="right_pg_area">
                      {
                        //<!-- Start Next Button -->
                      }
                      <div className="mu_header_next_btn">
                        <ReactPaginate
                          previousLabel={''}
                          nextLabel={''}
                          breakLabel={'...'}
                          breakClassName={'break-me'}
                          pageCount={pageCount}
                          marginPagesDisplayed={2}
                          pageRangeDisplayed={5}
                          onPageChange={this.handlePageClick}
                          containerClassName={'pagination'}
                          subContainerClassName={'pages pagination'}
                          activeClassName={'active'}
                          forcePage={this.state.selected}
                        />
                      </div>
                      {
                        //<!-- End Next Button -->
                      }
                    </div>
                  </div>
                </div>

                <div className="load-spiner fixed-loading">
                  {
                    (this.state.loaderspiner == true) ?
                      <ReactLoading type="spinningBubbles" color="#00BFFF" height={100} width={100} /> : ''
                  }
                </div>
                {
                  (this.state.showAlert == true) ?
                    <div id="alert-time_unit">
                      <AlertList
                        position={this.state.position}
                        alerts={this.state.alerts}
                        //timeout={this.state.timeout}
                        dismissTitle=""
                        onDismiss={this.onAlertDismissed.bind(this)}
                      />
                    </div> : ''
                }

              </div>
              {this.state.isEdit && (
                <EditStatus status_id={this.state.status_id} applied_to={this.state.applied_to} view_mode={this.state.view_mode} school_id={this.state.school_id} onCallback={this.hideEdit} />
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(Status)